"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Awards = exports.ALL_AWARDS = exports.PRELUDE_TWO_AWARDS = exports.NEW_OPS_AWARDS = exports.MOON_AWARDS = exports.ARES_AWARDS = exports.UTOPIA_PLANITIA_AWARDS = exports.AMAZONIS_PLANITIA_AWARDS = exports.TERRA_CIMMERIA_AWARDS = exports.ARABIA_TERRA_AWARDS = exports.VASTITAS_BOREALIS_AWARDS = exports.HELLAS_AWARDS = exports.ELYSIUM_AWARDS = exports.VENUS_AWARDS = exports.ORIGINAL_AWARDS = void 0;
const Landlord_1 = require("./Landlord");
const Banker_1 = require("./Banker");
const Scientist_1 = require("./Scientist");
const Thermalist_1 = require("./Thermalist");
const Miner_1 = require("./Miner");
const Venuphile_1 = require("./Venuphile");
const Industrialist_1 = require("./Industrialist");
const Celebrity_1 = require("./Celebrity");
const DesertSettler_1 = require("./DesertSettler");
const EstateDealer_1 = require("./EstateDealer");
const Benefactor_1 = require("./Benefactor");
const Cultivator_1 = require("./Cultivator");
const Magnate_1 = require("./Magnate");
const SpaceBaron_1 = require("./SpaceBaron");
const Excentric_1 = require("./Excentric");
const Contractor_1 = require("./Contractor");
const Entrepreneur_1 = require("./Entrepreneur");
const FullMoon_1 = require("../moon/FullMoon");
const LunarMagnate_1 = require("../moon/LunarMagnate");
const Adapter_1 = require("./vastitasBorealis/Adapter");
const Edgedancer_1 = require("./vastitasBorealis/Edgedancer");
const Hoarder_1 = require("./vastitasBorealis/Hoarder");
const Naturalist_1 = require("./vastitasBorealis/Naturalist");
const Voyager_1 = require("./vastitasBorealis/Voyager");
const Generator_1 = require("./arabiaTerra/Generator");
const Highlander_1 = require("./arabiaTerra/Highlander");
const Producer_1 = require("./arabiaTerra/Producer");
const Purist_1 = require("./arabiaTerra/Purist");
const Worker_1 = require("./arabiaTerra/Worker");
const Biologist_1 = require("./terraCimmeria/Biologist");
const Economizer_1 = require("./terraCimmeria/Economizer");
const Politician_1 = require("./terraCimmeria/Politician");
const Urbanist_1 = require("./terraCimmeria/Urbanist");
const Warmonger_1 = require("./terraCimmeria/Warmonger");
const Curator_1 = require("./amazonisPlanitia/Curator");
const Historian_1 = require("./amazonisPlanitia/Historian");
const Tourist_1 = require("./amazonisPlanitia/Tourist");
const Zoologist_1 = require("./amazonisPlanitia/Zoologist");
const Engineer_1 = require("./amazonisPlanitia/Engineer");
const Rugged_1 = require("./fanmade/Rugged");
const Botanist_1 = require("./utopiaPlanitia/Botanist");
const Investor_1 = require("./utopiaPlanitia/Investor");
const Metropolist_1 = require("./utopiaPlanitia/Metropolist");
const Blacksmith_1 = require("./preludeTwo/Blacksmith");
const Administrator_1 = require("./preludeTwo/Administrator");
const Traveller_1 = require("./preludeTwo/Traveller");
const Mogul_1 = require("./preludeTwo/Mogul");
const Gatherer_1 = require("./preludeTwo/Gatherer");
const Founder_1 = require("./preludeTwo/Founder");
const Landscaper_1 = require("./preludeTwo/Landscaper");
const Statesman_1 = require("./preludeTwo/Statesman");
const Constructor_1 = require("./preludeTwo/Constructor");
exports.ORIGINAL_AWARDS = [
    new Landlord_1.Landlord(),
    new Scientist_1.Scientist(),
    new Banker_1.Banker(),
    new Thermalist_1.Thermalist(),
    new Miner_1.Miner(),
];
exports.VENUS_AWARDS = [
    new Venuphile_1.Venuphile(),
];
exports.ELYSIUM_AWARDS = [
    new Celebrity_1.Celebrity(),
    new Industrialist_1.Industrialist(),
    new DesertSettler_1.DesertSettler(),
    new EstateDealer_1.EstateDealer(),
    new Benefactor_1.Benefactor(),
];
exports.HELLAS_AWARDS = [
    new Cultivator_1.Cultivator(),
    new Magnate_1.Magnate(),
    new SpaceBaron_1.SpaceBaron(),
    new Excentric_1.Excentric(),
    new Contractor_1.Contractor(),
];
exports.VASTITAS_BOREALIS_AWARDS = [
    new Adapter_1.Adapter(),
    new Edgedancer_1.Edgedancer(),
    new Hoarder_1.Hoarder(),
    new Naturalist_1.Naturalist(),
    new Voyager_1.Voyager(),
];
exports.ARABIA_TERRA_AWARDS = [
    new Generator_1.Generator(),
    new Highlander_1.Highlander(),
    new Producer_1.Producer(),
    new Purist_1.Purist(),
    new Worker_1.Worker(),
];
exports.TERRA_CIMMERIA_AWARDS = [
    new Biologist_1.Biologist(),
    new Economizer_1.Economizer(),
    new Politician_1.Politician(),
    new Urbanist_1.Urbanist(),
    new Warmonger_1.Warmonger(),
];
exports.AMAZONIS_PLANITIA_AWARDS = [
    new Curator_1.Curator(),
    new Engineer_1.Engineer(),
    new Historian_1.Historian(),
    new Tourist_1.Tourist(),
    new Zoologist_1.Zoologist(),
];
exports.UTOPIA_PLANITIA_AWARDS = [
    new Edgedancer_1.Edgedancer(),
    new Investor_1.Investor(),
    new Botanist_1.Botanist(),
    new Economizer_1.Economizer(),
    new Metropolist_1.Metropolist(),
];
exports.ARES_AWARDS = [
    new Entrepreneur_1.Entrepreneur(),
];
exports.MOON_AWARDS = [
    new FullMoon_1.FullMoon(),
    new LunarMagnate_1.LunarMagnate(),
];
exports.NEW_OPS_AWARDS = [
    new Rugged_1.Rugged(),
];
exports.PRELUDE_TWO_AWARDS = [
    new Administrator_1.Administrator(),
    new Blacksmith_1.Blacksmith(),
    new Constructor_1.Constructor(),
    new Founder_1.Founder(),
    new Gatherer_1.Gatherer(),
    new Landscaper_1.Landscaper(),
    new Mogul_1.Mogul(),
    new Statesman_1.Statesman(),
    new Traveller_1.Traveller(),
];
exports.ALL_AWARDS = Array.from(new Set([
    ...exports.ORIGINAL_AWARDS,
    ...exports.ELYSIUM_AWARDS,
    ...exports.HELLAS_AWARDS,
    ...exports.VENUS_AWARDS,
    ...exports.ARES_AWARDS,
    ...exports.MOON_AWARDS,
    ...exports.VASTITAS_BOREALIS_AWARDS,
    ...exports.ARABIA_TERRA_AWARDS,
    ...exports.TERRA_CIMMERIA_AWARDS,
    ...exports.AMAZONIS_PLANITIA_AWARDS,
    ...exports.UTOPIA_PLANITIA_AWARDS,
    ...exports.NEW_OPS_AWARDS,
    ...exports.PRELUDE_TWO_AWARDS
]));
var Awards;
(function (Awards) {
    Awards.ALL = exports.ALL_AWARDS;
    function getByName(name) {
        const award = exports.ALL_AWARDS.find((a) => a.name === name);
        if (award) {
            return award;
        }
        throw new Error(`Award ${name} not found.`);
    }
    Awards.getByName = getByName;
    function giveAwards(player, vpb) {
        player.game.fundedAwards.forEach((fundedAward) => {
            if (player.game.isSoloMode())
                return;
            const awardStr = fundedAward.award.name + ' award (funded by ' + fundedAward.player.name + ')';
            const players = player.game.getPlayers();
            players.sort((p1, p2) => fundedAward.award.getScore(p2) - fundedAward.award.getScore(p1));
            if (fundedAward.award.getScore(players[0]) > fundedAward.award.getScore(players[1])) {
                if (players[0].id === player.id)
                    vpb.setVictoryPoints('awards', 5, '1st place for ' + awardStr);
                players.shift();
                if (players.length > 1) {
                    if (fundedAward.award.getScore(players[0]) > fundedAward.award.getScore(players[1])) {
                        if (players[0].id === player.id)
                            vpb.setVictoryPoints('awards', 2, '2nd place for ' + awardStr);
                    }
                    else {
                        const score = fundedAward.award.getScore(players[0]);
                        while (players.length > 0 && fundedAward.award.getScore(players[0]) === score) {
                            if (players[0].id === player.id)
                                vpb.setVictoryPoints('awards', 2, '2nd place for ' + awardStr);
                            players.shift();
                        }
                    }
                }
            }
            else {
                const score = fundedAward.award.getScore(players[0]);
                while (players.length > 0 && fundedAward.award.getScore(players[0]) === score) {
                    if (players[0].id === player.id)
                        vpb.setVictoryPoints('awards', 5, '1st place for ' + awardStr);
                    players.shift();
                }
            }
        });
    }
    Awards.giveAwards = giveAwards;
})(Awards = exports.Awards || (exports.Awards = {}));
//# sourceMappingURL=Awards.js.map